import React from 'react';
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {withStyles} from "@material-ui/styles";
import MuiTable from "../common/MuiTable";
import {
    deleteTrainingRegister,
    exportReport,
    saveOrUpdateTrainingRegister,
    traningRegister,
    uploadFile
} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {Spinner} from "../common/Spinner";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        title: 'certificateId',
        field: 'certificateId',
        type: "numeric",
        hidden: true,
    },
    {
        title: 'Name',
        field: 'name',
        type: "string",
        cellStyle: {
            width: '20%'
        }
    },
    {
        title: 'Position',
        field: 'position',
        type: "string",
        cellStyle: {
            width: '20%'
        }
    },
    {
        title: 'Qualifications / Training',
        field: 'qualifications',
        type: "string",
        cellStyle: {
            width: '20%'
        }
    },
    {
        title: 'Expiry Date',
        field: 'expiryDate',
        type: "date",
        optional: true,
        cellStyle: {
            width: '20%'
        }
    },
    {
        title: 'Certificate',
        field: 'file',
        render: rowData => <span id={rowData.id}/>,
        type: 'fileupload',
    },
];

class TrainingRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            trainingRegister: [],
            isLoading: true,
        };
        this.loadTraningRegister = this.loadTraningRegister.bind(this);
        this.handleSaveOrUpdate = this.handleSaveOrUpdate.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.onFilterByChange = this.onFilterByChange.bind(this);
    }

    componentDidMount() {
        this.loadTraningRegister();
    }

    onFilterByChange(value) {
        console.log('setting value', value);
        this.setState({ filteredBy: value });
    }

    loadTraningRegister(callback) {
        traningRegister()
            .then(response => {
                console.log(response);
                const names = response.map(item => {
                    return { "name" : item.name, "position": item.position }
                });

                let defaultProps = {
                    options: names,
                    getOptionLabel: (option) => option.name + " (" + option.position + ")",
                };

                this.setState({
                    trainingRegister: response,
                    defaultProps: defaultProps,
                    isLoading: false,
                });
                if (callback) {
                    callback();
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSaveOrUpdate(trainingRegisterDtoRequest) {
        console.log(trainingRegisterDtoRequest);
        saveOrUpdateTrainingRegister(trainingRegisterDtoRequest)
            .then((updatedRegister) => {
                console.log("updatedRegister id " + updatedRegister.id);
                console.log("updatedRegister " + updatedRegister);
                console.log(this.state);
                if (trainingRegisterDtoRequest.file) {
                    this.handleFileUpload(updatedRegister.id, trainingRegisterDtoRequest.file);
                } else {
                    this.loadTraningRegister();
                }
                NotificationManager.success('Success', 'The Training Register has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleDelete(trainingRegisterDtoRequest) {
        console.log(trainingRegisterDtoRequest);
        deleteTrainingRegister(trainingRegisterDtoRequest)
            .then(() => {
                this.loadTraningRegister();
                NotificationManager.success('Success', 'The Training Register has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== ''
            && newData.position && newData.position !== ''
            && newData.qualifications && newData.qualifications !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name, Position and Qualifications are required fields', 5000);
        }
        return isValid;
    }

    handleFileUpload(trainingRecordId, selectedFile) {
        const callback = (status, res) => {
            console.log("result " + status);
            console.log("result " + res);
            if (status === 200) {
                this.loadTraningRegister();
                //NotificationManager.success('Success', 'File has been successfully uploaded!', 5000);
            } else {
                console.log(res);
                //NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            }
        };
        uploadFile("/training-register/fileUpload", trainingRecordId, selectedFile, callback);
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                TRAINING REGISTER
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Autocomplete
                    {...this.state.defaultProps}
                    id="open-on-focus"
                    openOnFocus
                    onChange={(event, value) => this.onFilterByChange(value) }
                    renderInput={
                        (params) =>
                            <TextField {...params} label="Type or Select here to add a record for an existing person" margin="normal" />
                    }
                    style={{ width: "600px", float: "right" }}
                />
                <div style={{ clear: "both" }}/>
                <MuiTable
                    title="Training Register"
                    columns={columns}
                    data={state.trainingRegister}
                    onAdd={this.handleSaveOrUpdate}
                    onUpdate={this.handleSaveOrUpdate}
                    onDelete={this.handleDelete}
                    isValid={this.isValid}
                    defaultData={this.state.filteredBy}
                    onExport={() => exportReport('/training-register/export')}
                    handleFileUpload={this.handleFileUpload}
                    allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                />
            </Paper>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(TrainingRegister);
